import type { OtpTrackingChannel, OtpVerificationParams } from "./types";
import { useShellStore } from "@/features/shell/stores/shellStore";

const modalChannelMap: Record<string, OtpTrackingChannel> = {
  phoneVerification: "mobile",
  emailVerification: "email",
  signupVerification: "mobile",
  verifyExisting: "mobile",
};

export const getChannelFromModal = (
  channel: OtpVerificationParams["channel"],
): OtpTrackingChannel => {
  if (channel === "dynamic") {
    const modal = useShellStore.getState().modal;
    return modalChannelMap[modal ?? ""] ?? "mobile";
  }

  return channel;
};
